import { ChangeDetectionStrategy, Component, OnInit, TemplateRef, ViewChild, inject } from '@angular/core';
import {
  AdminServerTableCellContext,
  AdminServerTableColumn,
  AdminServerTablePaginationState,
} from '../../../shared/table/models/admin-server-table.model';
import { CotizacionesCementoStore, CementoCotizacionVm } from '../../../stores/cotizaciones-cemento.store';
import { CotizacionesCementoUiEffectsService } from '../ui-effects/cotizaciones-cemento-ui-effects.service';
import { SwalAlertService } from 'src/app/services/swal-alert.service';
import { buildCotizacionesCementoColumns } from './cotizacion-cemento-table.columns';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-cotizacion-cemento-tabla',
  templateUrl: './cotizacion-cemento-tabla.component.html',
  styleUrls: ['./cotizacion-cemento-tabla.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CotizacionCementoTablaComponent implements OnInit {
  @ViewChild('priceCellTpl', { static: true })
  priceCellTpl!: TemplateRef<AdminServerTableCellContext<CementoCotizacionVm>>;
  @ViewChild('actionsCellTpl', { static: true })
  actionsCellTpl!: TemplateRef<AdminServerTableCellContext<CementoCotizacionVm>>;

  readonly store = inject(CotizacionesCementoStore);
  private readonly uiEffects = inject(CotizacionesCementoUiEffectsService);
  private readonly swal = inject(SwalAlertService);

  readonly tableColumns: AdminServerTableColumn<CementoCotizacionVm>[] = [];

  ngOnInit(): void {
    this.tableColumns.push(
      ...buildCotizacionesCementoColumns({
        priceCellTemplate: this.priceCellTpl,
        actionsCellTemplate: this.actionsCellTpl,
      }),
    );
  }

  get paginationState(): AdminServerTablePaginationState {
    return {
      page: this.store.page(),
      pageSize: this.store.pageSize(),
      total: this.store.totalItems(),
      totalPages: this.store.totalPages(),
      hasPreviousPage: this.store.hasPreviousPage(),
      hasNextPage: this.store.hasNextPage(),
      pageStartIndex: this.store.pageStartIndex(),
      pageEndIndex: this.store.pageEndIndex(),
      pageSizeOptions: [10, 20, 50, 100],
    };
  }

  readonly trackByItem = (_: number, item: CementoCotizacionVm): string => item.trackId;

  onSearchTermChange(value: string | number): void {
    this.store.setSearchTerm(String(value ?? ''));
  }

  onOrderingChange(value: string): void {
    this.store.setOrdering(value);
  }

  onPageChange(value: number): void {
    this.store.setPage(value);
  }

  onPageSizeChange(value: number): void {
    this.store.setPageSize(value);
  }

  onDownloadPdf(orderBuy: string): void {
    this.store.downloadPdf(orderBuy).subscribe(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Cotizacion_${orderBuy}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }

  onExportExcel(): void {
    this.store.exportExcel().subscribe(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Cotizaciones_Cemento.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }

  async onOpenSearchPdf(): Promise<void> {
    const result = await this.swal.showTextInputSwal(
      'Generar PDF Cotización',
      'OD9999999999',
      'Buscar',
    );
    if (result) {
      this.onDownloadPdf(result);
    }
  }

  onSeeVariables(row: CementoCotizacionVm): void {
    Swal.fire({
      title: `Detalle Cotización ${row.order_buy}`,
      html: `
        <div class="text-start">
          <p><strong>RUT:</strong> ${row.rut}</p>
          <p><strong>Giro:</strong> ${row.giro}</p>
          <p><strong>Email:</strong> ${row.email}</p>
          <p><strong>Teléfono:</strong> ${row.phone}</p>
          <p><strong>Dirección:</strong> ${row.address_dispatch}</p>
          <p><strong>Incoterm:</strong> ${row.incoterm_display}</p>
        </div>
      `,
      icon: 'info',
      confirmButtonText: 'Cerrar',
    });
  }
}
